import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=75640594"
import script from "./base-select.ts?vue&type=script&lang=ts&external"
export * from "./base-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75640594')) {
      api.createRecord('75640594', component.options)
    } else {
      api.reload('75640594', component.options)
    }
    module.hot.accept("./base-select.vue?vue&type=template&id=75640594", function () {
      api.rerender('75640594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Select/base-select.vue"
export default component.exports